export const MAX_TOTAL_UPLOAD_SIZE = 12 * 1024 * 1024; // 12MB
